module.exports = __webpack_public_path__ + "static/media/Homepage_FPG_Assorti_Green-Energy.3be3db4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Homepage/Homepage_FPG_Assorti_Green-Energy.jpg
// module id = 688
// module chunks = 0